module.exports = __webpack_public_path__ + "routes/StatusGmin/waiting-wheel-300x300.gif?1fce61e9";


//////////////////
// WEBPACK FOOTER
// ./routes/StatusGmin/waiting-wheel-300x300.gif
// module id = 1802
// module chunks = 0